export default "__VITE_ASSET__c4145ba1__"